import onOffsetHooks from "./on-property-percents/on-offset-hooks";
import deleteActiveTriggers from "./on-step-status/delete-active-triggers";
import onStatusCycle from "./percents/on-status-cycle";

/**
 *
 * @param {TemporaryDataProps} data
 */
const onCoordinatesTimelineStatus = (data) => {
  const main = /** @type {MainClassProps} */ (data.get("main"));
  const trigger = /** @type {TriggerProps} */ (data.get("trigger"));
  const timeline = /** @type {TimelineMapProps} */ (data.get("timeline"));

  const overall = /** @type {Number} */ (timeline.get("percents-overall"));
  const last = /** @type {Number} */ (timeline.get("last-overall"));
  const statuses = /** @type {Array<Number>} */ (timeline.get("statuses"));
  const finished = statuses.length && statuses.every((value) => value > 0);

  const enter = overall - last > 0;

  /** Enter started */
  if (overall > 0 && last === 0) {
    /** Check timeline references */
    onStatusCycle(timeline, true, "start", "started", 0);
  }
  /** Enter finished */
  if (overall === 1 && last < 1) {
    /** Check timeline references */
    onStatusCycle(timeline, true, "finish", "finished", 0);
  }
  /** Leave started */
  if (overall < 1 && last === 1) {
    /** Check references */
    onStatusCycle(timeline, false, "start", "started", 0);
  }
  /** Leave finished */
  if (overall === 0 && last > 0) {
    /** Check timeline references */
    onStatusCycle(timeline, false, "finish", "finished", 0);
  }

  if (timeline.get("has-offset-hook")) {
    onOffsetHooks(timeline, enter, overall, false);
  }

  if (finished) {
    deleteActiveTriggers(main, trigger);
  }

  timeline.set("last-overall", overall);
};

export default onCoordinatesTimelineStatus;
